import { Sparkles } from "lucide-react";

// what the compiler did automatically on this build (from report.optimization)
function rows(o) {
  const hero = o.stock_hero || {};
  const out = [
    ["Foto principali copiate nel sito (WebP + AVIF)", hero.requested ? `${hero.self_hosted}/${hero.requested}` : "—", hero.failed?.length ? `${hero.failed.length} rimaste sul CDN` : null],
    ["Prima immagine precaricata con priorità alta", `${o.hero_preload ?? 0}/${o.pages} pagine`],
    ["Immagini con versioni per ogni larghezza (srcset)", o.srcset ?? 0, o.sizes ? `${o.sizes} con larghezze calcolate dal layout` : null],
    ["Dimensioni aggiunte alle immagini (niente salti)", o.sized ?? 0],
    ["Varianti WebP / AVIF generate", `${o.webp_variants ?? 0} / ${o.avif_variants ?? 0}`, "AVIF solo quando è almeno il 10 % più leggero"],
    ["Font del titolo precaricato", `${o.font_preload ?? 0}/${o.pages} pagine`],
    ["Nomi accessibili aggiunti a link, pulsanti e campi", (o.named_links || 0) + (o.named_buttons || 0) + (o.named_fields || 0) + (o.titled_iframes || 0)],
    ["Testo visibile incluso nel nome dei link", o.label_in_name ?? 0],
    ["Immagini decorative marcate per i lettori di schermo", o.decorative_alt ?? 0],
    ["Indirizzi nella sitemap.xml", o.sitemap_urls ?? 0],
  ];
  if (o.local_images) out.splice(4, 0, ["Immagini caricate del progetto", `${o.local_orig_kb} KB → ${o.local_webp_kb} KB`, "originali mai modificati"]);
  return out;
}

export default function OptimizationSummary({ optimization }) {
  if (!optimization) return null;
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4" data-testid="quality-optimizations">
      <p className="flex items-center gap-1.5 text-sm font-semibold text-slate-900"><Sparkles size={14} className="text-sky-600" />Ottimizzazioni automatiche di questa compilazione</p>
      <dl className="mt-3 grid gap-x-6 gap-y-2 sm:grid-cols-2">
        {rows(optimization).map(([label, value, note]) => (
          <div key={label} className="flex items-baseline justify-between gap-3 border-b border-slate-100 pb-1.5 text-xs">
            <dt className="text-slate-600">{label}{note && <span className="block text-[11px] text-slate-400">{note}</span>}</dt>
            <dd className="shrink-0 font-semibold tabular-nums text-slate-900">{value}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
